import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-watanews',
  templateUrl: 'watanews.html'
})
export class WatanewsPage {
  constructor(public navCtrl: NavController, public navParams: NavParams) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad WatanewsPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/watanews/watanews.ts